import React from 'react';
import PropTypes from 'prop-types';
import CreditCardCard from './CreditCardCard';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    minHeight: 300,
    marginBottom: '1rem',
    marginTop: '1rem',
  }
});

const CreditCardList = ({ cards, selected, onSelect, onDelete}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {cards.map(card =>
        <CreditCardCard
          key={card.token}
          card={card}
          selected={card === selected}
          onClick={() => onSelect(card)}
          onDelete={() => onDelete(card)}
        />
      )}
    </div>
  );
};

CreditCardList.propTypes = {
  cards: PropTypes.array.isRequired,
  selected: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CreditCardList;
